import { render } from "./PurchasesFilterForm.vue?vue&type=template&id=df6d121a&scoped=true"
import script from "./PurchasesFilterForm.vue?vue&type=script&lang=js"
export * from "./PurchasesFilterForm.vue?vue&type=script&lang=js"

import "./PurchasesFilterForm.vue?vue&type=style&index=0&id=df6d121a&lang=css&scoped=true"
import "@vueform/slider/themes/default.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df6d121a"]])

export default __exports__